import request from '../axiosInterceptor'

const api = {
  getAllRulesAndEscalations(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/list`,
      method: 'get',
    })
  },
  getRuleAndEscalationDetail(id: any, ruleId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/details?rule_id=${ruleId}`,
      method: 'get',
    })
  },
  postRuleAndEscalationPreview(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/notification/preview`,
      method: 'post',
      data: data,
    })
  },
  getRuleAndEscalationId(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/next/rule-id`,
      method: 'get',
    })
  },
  postCreateRulesAndEscalation(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/create`,
      method: 'post',
      data: data,
    })
  },
  validateRulesAndEscalationConditions(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/validate-conditions`,
      method: 'post',
      data: data,
    })
  },
  putEditRulesAndEscalation(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/update`,
      method: 'put',
      data: data,
    })
  },
  // postChangeWorkspace(data: any) {
  //   return request({
  //     url: `${process.env.REACT_APP_API_BASEURL}v1/auth/change-workspace`,
  //     method: 'post',
  //     data: data,
  //   })
  // },
}

export default api
